<template>
  <div>
    <b-card class="no-border">
      <b-card>
        <template slot="header">
          <b-row align-h="between">
            <b-col md="6">
              <b-input-group>
                <date-picker
                  confirm
                  :editable="false"
                  :clearable="false"
                  :shortcuts="false"
                  id="range-date"
                  v-model="dateRange"
                  lang="en"
                  type="date"
                  range-separator="to"
                  partial-update
                  format="DD MMM YYYY" range></date-picker>
                <div class="text-danger mt-2" v-show="dateHelper">Not allowed select date more than 7 days</div>
              </b-input-group>
            </b-col>
            <b-col md="3"></b-col>
            <b-col md="3">
              <b-input-group v-show="!isEmptyData && loadedData">
                <b-form-input
                  v-model="filter"
                  type="search"
                  placeholder="Search"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </template>
        <b-table v-if="!isEmptyData && !failedFetch"
          :busy="!loadedData" striped responsive
          :fields="table.fields"
          :items="table.items"
          :emptyFilteredText="emptyFilteredText"
          :emptyText="loadingTableText"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter" show-empty>
          <template #empty="scope">
            <div class="center--text text-muted">{{ scope.emptyText }}</div>
          </template>
          <template #emptyfiltered="scope">
            <div class="center--text text-muted">{{ scope.emptyFilteredText }}</div>
          </template>
          <template #cell(order)="data">
            <router-link :to="`/shipment_md/orders/${get(data.value, 'id')}`">{{get(data.value, 'number')}}</router-link>
          </template>
          <template #cell(shipment)="data">
            <router-link :to="`/shipment_md/shipments/${get(data.value, 'id')}`">{{get(data.value, 'number')}}</router-link>
          </template>
          <template #cell(customer)="data">
            <div>
              <div>{{get(data.value, 'name')}}</div>
              <template v-if="data.value.address">
                <div class="small text-muted">{{data.value.address.address1}}</div>
                <div class="small text-muted">{{data.value.address.city}} {{data.value.address.state}} {{data.value.address.zip_code}}</div>
              </template>
            </div>
          </template>
          <template #cell(confirmation)="data">{{formatDateTime(get(data.value, 'created_at'))}}</template>
          <template #cell(location_accuracy)="data">
            <div v-if="checkValidDestination(data.item) && checkValidGPSPosition(data.item)"><span v-html="formatDistance(data.value)"></span></div>
            <div v-if="!checkValidDestination(data.item)" class="text-danger small">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              Invalid destination
            </div>
            <div v-if="!checkValidGPSPosition(data.item)" class="text-danger small">
              <i class="fa fa-map-marker" aria-hidden="true"></i>
              No GPS Position
            </div>
          </template>
          <template #cell(action)="data">
            <b-button
              title="Show Map"
              class="mb-2"
              :disabled="!checkValidDestination(data.item) && !checkValidGPSPosition(data.item)"
              @click="showMap(data.item)"
              size="sm" pill
              :variant="`${!checkValidDestination(data.item) && !checkValidGPSPosition(data.item) ? 'outline-secondary' : 'outline-primary'}`">
              <i class="fa icon-map" aria-hidden="true"></i>
            </b-button>
            <b-button
              @click="updateCustomerLocation(data.item)"
              title="Update customer location from GPS Location"
              class="mb-2"
              v-if="checkValidGPSPosition(data.item)"
              variant="outline-warning"
              size="sm" pill>
              <i class="fa fa-map-marker" aria-hidden="true"></i>
            </b-button>
            <b-button
              @click="copyCoordinate(data.item, 'gps')"
              title="Copy GPS Coordinate"
              class="mb-2"
              v-if="checkValidGPSPosition(data.item)"
              variant="outline-primary"
              size="sm" pill>
              <i class="fa fa-truck" aria-hidden="true"></i>
            </b-button>
            <b-button
              @click="copyCoordinate(data.item, 'customer')"
              title="Copy Customer Coordinate"
              class="mb-2"
              v-if="checkValidDestination(data.item)"
              variant="outline-primary"
              size="sm" pill>
              <i class="fa fa-home" aria-hidden="true"></i>
            </b-button>
          </template>
        </b-table>
        <b-alert show v-else-if="isEmptyData && !isFailedFetch" variant="warning">No available data</b-alert>
        <b-alert show v-else-if="isFailedFetch" variant="danger">Failed fetch data</b-alert>
        <b-pagination
          v-show="!isEmptyData && loadedData && !forceHidePagination"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-card>
    </b-card>
    <b-modal @hide="onCloseModal" hide-footer size="xl" ref="modal" :title="modalTitle">
      <div v-if="mapState === 'loading'">
        <p style="margin-bottom: 0px;">Please wait...</p>
      </div>
      <div v-if="mapState === 'ready'">
        <l-map
          ref="map"
          @ready="onMapReady"
          :style="getMapStyles()"
          :bounds="bounds"
          :zoom.sync="zoom"
          :center="center">
          <l-tile-layer :url="url"></l-tile-layer>
          <l-marker v-for="(marker, indexMarker) in markerPoints"
            :attribution="marker.type"
            :key="`marker-${indexMarker}`"
            :lat-lng="getMarkerPoint(marker)"
            :icon="getMarkerIcon(marker)">
            <l-tooltip :options="tooltipOptions">
              <p style="margin-bottom: 0px;">
                <span>
                  <b>{{ get(marker, 'name') }}</b>
                </span>
              </p>
              <p style="margin-bottom: 0px;">{{ get(marker, 'address') }}</p>
            </l-tooltip>
          </l-marker>
        </l-map>
      </div>
    </b-modal>
    <sweet-modal blocking @close="onCloseModalUpdateLocation" :title="`Update location (<b>${get(targetUpdateLocation, 'customer.name')}</b>)`" ref="modalUpdateLocation" width="50%">
      <div class="location-form-container">
        <b-form class="fix-location-form" @submit.prevent="submitUpdateLocation()">
          <div v-if="destinationsListOrder.length !== 0" class="setup-check-ava-locations">
            <b-form-checkbox
              v-model="replaceAvailableLocationsCheckbox"
              name="available-locations-check"
              value="yes-replace"
              unchecked-value="no-create-new"
            > Update Existing Location </b-form-checkbox>
          </div>
          <div v-if="isReplaceAvailableLocations" style="text-align: left;" class="available-location-container">
            <b-form-group label="Available Locations">
              <b-form-radio-group
                v-validate="'required'"
                :class="{'is-invalid': errors.has('target-location')}"
                v-model="destinationSelectedOrder"
                :options="destinationsListOrder"
                name="target-location"
                stacked
              >
              </b-form-radio-group>
              <b-form-feedback>{{ errors.first('target-location') }}</b-form-feedback>
            </b-form-group>
          </div>
          <hr v-if="destinationsListOrder.length !== 0">
          <div class="form-input-lonlat">
            <div class="form-row col-md-12">
              <label>Location Code</label>
              <b-form-input
                name="code"
                v-validate="'required'"
                :class="{'is-invalid': errors.has('code')}"
                :disabled="isReplaceAvailableLocations"
                v-model="fixDestinationForm.locationCode"
                class="mb-2"
                type="text" placeholder="Location Code"></b-form-input>
              <b-form-feedback>{{ errors.first('code') }}</b-form-feedback>
            </div>
            <div class="form-row col-md-12">
              <label>Name</label>
              <b-form-input
                name="name"
                v-validate="'required'"
                :class="{'is-invalid': errors.has('name')}"
                :disabled="isReplaceAvailableLocations"
                v-model="fixDestinationForm.name"
                class="mb-2"
                type="text" placeholder="Name"></b-form-input>
              <b-form-feedback>{{ errors.first('name') }}</b-form-feedback>
            </div>
            <div class="form-row col-md-12">
              <label>Latitude</label>
              <b-form-input
                name="latitude"
                v-validate="'required'"
                :class="{'is-invalid': errors.has('latitude')}"
                v-model="fixDestinationForm.latitude"
                class="mb-2"
                type="text" placeholder="Exp. -4.12027403932379"></b-form-input>
              <b-form-feedback>{{ errors.first('latitude') }}</b-form-feedback>
            </div>
            <div class="form-row col-md-12">
              <label>Longitude</label>
              <b-form-input
                name="longitude"
                v-validate="'required'"
                :class="{'is-invalid': errors.has('longitude')}"
                v-model="fixDestinationForm.longitude"
                class="mb-2"
                type="text" placeholder="Exp. 24.5102593302727"></b-form-input>
              <b-form-feedback>{{ errors.first('longitude') }}</b-form-feedback>
            </div>
          </div>
          <div class="footer-form">
            <hr>
            <b-button
              type="submit"
              class="pull-left"
              variant="primary">{{ textButtonFixDestination }}</b-button>
          </div>
        </b-form>
      </div>
    </sweet-modal>
    <sweet-modal hide-close-button blocking ref="modalLoading" width="50%">
      {{ stateLoadText }}
    </sweet-modal>
  </div>
</template>

<script>
import L from 'leaflet';
import dateMixin from '@/mixins/date';
import DatePicker from 'vue2-datepicker';
import { get, isEmpty, orderBy } from 'lodash';
import { format } from 'date-fns';
import moment from 'moment';
import { LMap, LTileLayer, LMarker, LTooltip, LIcon, LCircle } from 'vue2-leaflet';

export default {
  name: 'location_accuracy',
  mixins: [dateMixin],
  components: {
    DatePicker,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LIcon,
    LCircle,
  },
  data() {
    return {
      dateRange: [
        format(new Date(), 'YYYY-MM-DD'),
        format(new Date(), 'YYYY-MM-DD'),
      ],
      currentPage: 1,
      perPage: 10,
      modalTitle: '',
      loadedData: false,
      failedFetch: false,
      dateHelper: false,
      stateLoadText: '',
      forceHidePagination: false,
      targetUpdateLocation: null,
      textButtonFixDestination: 'Submit',
      fixDestinationForm: {
        locationCode: '-',
        name: '',
        latitude: '',
        longitude: '',
      },
      destinationSelectedOrder: null,
      destinationsListOrder: [],
      locationData: [],
      isReplaceAvailableLocations: false,
      replaceAvailableLocationsCheckbox: 'no-create-new',
      filter: null,
      emptyFilteredText: 'No match data',
      loadingTableText: 'Loading data',
      table: {
        fields: [
          {
            key: 'order',
            label: 'Order',
          },
          {
            key: 'shipment',
            label: 'Shipment',
          },
          {
            key: 'customer',
            label: 'Customer',
          },
          {
            key: 'confirmation',
            label: 'Confirmation Date',
          }, {
            key: 'location_accuracy',
            label: 'Location Accuracy',
          },
          {
            key: 'action',
            label: 'Action',
          },
        ],
        items: [],
      },
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      center: [-6.17543846855061, 106.86290799928327],
      coordinates: [0, 0],
      zoom: 13,
      tooltipOptions: {
        permanent: true,
        direction: 'top',
        offset: L.point(0, -30),
      },
      icons: {
        iconRetinaUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-icon-2x.png',
        iconUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-icon.png',
        shadowUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-shadow.png',
      },
      bounds: L.latLngBounds(
        { lat: 51.476483373501964, lng: -0.14668464136775586 },
        { lat: 51.52948330894063, lng: -0.019140238291583955 },
      ),
      markerPoints: [],
      mapState: 'loading',
    };
  },
  created() {
    String.prototype.toProperCase = function toProperCase() { // eslint-disable-line
      return this.replace(/\w\S*/g, (txt) => (txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())); // eslint-disable-line
    };
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'location_accuracy', name: 'Customer Location Acuracy' },
    ]);
    this.loadData();
  },
  computed: {
    location_accuracy() {
      const data = this.$store.getters['location_accuracy/location_accuracy'];
      return data
        .sort((d1, d2) => (d1.confirmation.created_at > d2.confirmation.created_at ? 1 : -1));
    },
    isEmptyData() {
      return this.loadedData && isEmpty(this.location_accuracy);
    },
    isFailedFetch() {
      return this.loadedData && this.failedFetch;
    },
    totalRows() {
      return this.location_accuracy.length;
    },
  },
  watch: {
    location_accuracy(data) {
      this.table.items.splice(0);
      data.forEach((d) => {
        this.table.items.push(d);
      });
    },
    dateRange(data) {
      const diff = moment(data[1]).diff(data[0], 'days');
      const isMoreThan7Days = diff > 6;
      this.dateHelper = isMoreThan7Days;
      if (!isMoreThan7Days) { this.loadData(); }
    },
    filter(data) {
      if (data) {
        this.currentPage = 1;
        this.forceHidePagination = true;
      } else {
        this.forceHidePagination = false;
      }
    },
    replaceAvailableLocationsCheckbox(value) {
      const isReplace = value === 'yes-replace';
      this.isReplaceAvailableLocations = isReplace;

      if (isReplace) {
        this.fixDestinationForm.locationCode = '';
      } else {
        const externalId = this.get(this.targetUpdateLocation, 'customer.external_id', '');
        this.fixDestinationForm.locationCode = externalId ? externalId.replace('PRB-', '') : '-';
        this.destinationSelectedOrder = null;
      }
      this.fixDestinationForm.name = '';
    },
    destinationSelectedOrder(locationId) {
      const selectedLocation = this.locationData.find(dt => (dt.id === locationId));
      this.fixDestinationForm.locationCode = selectedLocation.code ? selectedLocation.code.replace('PRB-', '') : '-';
      this.fixDestinationForm.name = selectedLocation.name;
    },
  },
  methods: {
    get(dt, key, def = '-') {
      return get(dt, key, def);
    },
    formatNumber(numb) {
      return numb.toFixed(2);
    },
    formatDistance(value) {
      const distance = value < 1
        ? `<span class="font-weight-bold">${this.formatNumber(value * 1e3)}</span>m`
        : `<span class="font-weight-bold">${this.formatNumber(value)}</span>km`;
      return distance;
    },
    loadData() {
      this.loadedData = false;
      this.$store.commit('location_accuracy/SET_QUERY_DATE', this.dateRange);
      return this.$store
        .dispatch('location_accuracy/LOAD_DATA')
        .then(() => {
          this.loadedData = true;
          this.failedFetch = false;
        })
        .catch((error) => {
          this.loadedData = true;
          this.failedFetch = true;
          console.error(error);
        });
    },
    checkValidDestination(data) {
      return !isEmpty(data.order.destination);
    },
    checkValidGPSPosition(data) {
      const pos = this.get(data, 'metadata.gps_location');
      return pos.longitude !== 0 && pos.latitude !== 0;
    },
    setStateModalLoading(show, text = '') {
      this.stateLoadText = text;
      if (show) {
        this.$refs.modalLoading.open();
      } else {
        this.$refs.modalLoading.close();
      }
    },
    copyCoordinate(data, type) {
      let coorditane = '';

      if (type === 'gps') {
        coorditane = [
          this.get(data, 'metadata.gps_location.latitude'),
          this.get(data, 'metadata.gps_location.longitude'),
        ].join(',');
      } else {
        coorditane = [
          this.get(data, 'metadata.customer_location.latitude'),
          this.get(data, 'metadata.customer_location.longitude'),
        ].join(',');
      }

      if (this.clipboardCopy(coorditane)) {
        this.$swal('Success', `Successfully copy ${type} coordinate to clipboard.`, 'success');
      } else {
        this.$swal('Failed', `Failed copy ${type} coordinate to clipboard.`, 'error');
      }
    },
    getLocationsByCompanyId(id) {
      return this.$store.dispatch('shipment_md/locations/GET_LOCATIONS_BY_COMPANYID', { company_id: id });
    },
    updateCustomerLocation(data) {
      this.$swal({
        title: 'Action Confirmation',
        text: 'Are you sure want to update customer location form GPS location ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          const { id: customerId } = data.customer;
          const externalId = this.get(data, 'customer.external_id', '');
          this.fixDestinationForm.locationCode = externalId ? externalId.replace('PRB-', '') : '';
          this.fixDestinationForm.longitude = this.get(data, 'metadata.gps_location.longitude', 0);
          this.fixDestinationForm.latitude = this.get(data, 'metadata.gps_location.latitude', 0);
          this.targetUpdateLocation = data;

          this.setStateModalLoading(true, 'Checking available locations...');
          this.getLocationsByCompanyId(customerId).then((locations) => {
            if (locations.length) {
              const locationOptions = locations.map(dt => ({ text: dt.name, value: dt.id }));
              this.destinationsListOrder = orderBy(locationOptions, ['text'], ['asc']);
              this.locationData = locations;
            } else {
              this.destinationsListOrder = [];
            }

            const orderDestinationId = this.get(data, 'order.destination.id', null);
            if (orderDestinationId) {
              this.replaceAvailableLocationsCheckbox = 'yes-replace';
              this.destinationSelectedOrder = orderDestinationId;
            }

            setTimeout(() => {
              this.setStateModalLoading(false);
              this.$refs.modalUpdateLocation.open();
            }, 1e3);
          });
        }
      });
    },
    clipboardCopy(text) {
      const el = document.createElement('textarea');
      el.value = text;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const selected = document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false;
      el.select();

      let success = false;
      try {
        success = document.execCommand('copy');
        document.body.removeChild(el);
      } catch (err) {
        console.log(err);
      }

      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }

      return success;
    },
    onCloseModalUpdateLocation() {
      this.replaceAvailableLocationsCheckbox = 'no-create-new';
      this.destinationSelectedOrder = null;
    },
    submitUpdateLocation() {
      this.validate().then((valid) => {
        if (valid) {
          const orderId = this.get(this.targetUpdateLocation, 'order.id');
          const customerId = this.get(this.targetUpdateLocation, 'customer.id');
          const {
            locationCode: code, longitude, latitude, name,
          } = this.fixDestinationForm;
          const payloads = {
            code,
            name,
            longitude: parseFloat(longitude),
            latitude: parseFloat(latitude),
            type: 1,
            metadata: {
              radius: 50,
            },
            geometry: {
              type: 'Point',
              coordinates: [parseFloat(latitude), parseFloat(longitude)],
            },
            company_id: customerId,
          };

          if (this.isReplaceAvailableLocations) {
            payloads.id = this.destinationSelectedOrder;
          }

          this.textButtonFixDestination = 'Processing...';
          this.createUpdateLocation(payloads).then((resp) => {
            const { id: newLocationId } = resp;
            this.assignOrderDestination(orderId, newLocationId).then(() => {
              this.textButtonFixDestination = 'Success';
              setTimeout(() => {
                this.textButtonFixDestination = 'Submit';
                this.resetFixDestinationForm();
                this.$refs.modalUpdateLocation.close();
                this.loadData();
              }, 1e3);
            });
          });
        } else {
          const errorFields = this.$validator.errors.items.map(dt => dt.field);
          if (errorFields.includes('target-location')) {
            document.querySelector('.available-location-container').scrollBy(0, 150);
          }
        }
      });
    },
    resetFixDestinationForm() {
      this.fixDestinationForm.locationCode = '';
      this.fixDestinationForm.name = '';
      this.fixDestinationForm.longitude = '';
      this.fixDestinationForm.latitude = '';
    },
    createUpdateLocation(payloads) {
      const isUpdate = payloads.hasOwnProperty('id'); // eslint-disable-line
      const action = isUpdate ? 'UPDATE_DATA' : 'CREATE_DATA';
      return this.$store.dispatch(`shipment_md/locations/${action}`, payloads);
    },
    assignOrderDestination(orderId, locationId) {
      return this.$store.dispatch('shipment_md/orders/UPDATE_DATA', {
        id: orderId,
        destination: {
          id: locationId,
        },
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    onCloseModal() {
      this.markerPoints = [];
    },
    showMap(data) {
      const customerName = this.get(data, 'customer.name', '');
      const vehicleRegNo = this.get(data, 'shipment.vehicle.reg_no');
      this.modalTitle = `Location ${customerName} and Vehicle (${vehicleRegNo})`;
      this.$refs.modal.show();

      if (this.checkValidDestination(data)) {
        this.markerPoints.push({
          type: 'customer',
          name: this.get(data, 'customer.name'),
          longitude: this.get(data, 'metadata.customer_location.longitude'),
          latitude: this.get(data, 'metadata.customer_location.latitude'),
          address: this.get(data, 'customer.address.address1', '').toProperCase(),
        });
      }
      if (this.checkValidGPSPosition(data)) {
        this.markerPoints.push({
          type: 'gps',
          name: this.get(data, 'shipment.vehicle.reg_no'),
          longitude: this.get(data, 'metadata.gps_location.longitude'),
          latitude: this.get(data, 'metadata.gps_location.latitude'),
          address: this.get(data, 'metadata.gps_location.roadname', '').toProperCase(),
        });
      }

      this.bounds = L.latLngBounds(this.markerPoints.map(pt => (
        { lat: pt.latitude, lng: pt.longitude }
      )));
      this.mapState = 'loading';
      setTimeout(() => {
        this.mapState = 'ready';
      }, 5e2);
    },
    onMapReady() {
      setTimeout(() => {
        this.$refs.map.mapObject.invalidateSize();
        if (this.markerPoints.length === 1) {
          this.$refs.map.setZoom(18);
        }
      }, 1e2);
    },
    getMapStyles() {
      const height = window.innerHeight - 180;
      const styles = `height: ${height}px; width: 100%;`;
      return styles;
    },
    getMarkerIcon(data) {
      let iconName = '';
      let iconPath = 'tms';
      if (data.type === 'customer') {
        iconName = 'origin-area';
      } else if (data.type === 'gps') {
        iconName = 'truck_in_movement';
        iconPath = 'bookmark';
      }
      const icon = L.icon({
        iconUrl: `https://secure-gps.street-directory.com.au/assets/img/${iconPath}/${iconName}.png`,
        iconSize: [32, 32],
        iconAnchor: [16, 32],
      });
      return icon;
    },
    getMarkerPoint(data) {
      const { longitude, latitude } = data;
      return {
        lat: latitude,
        lng: longitude,
      };
    },
  },
};
</script>

<style lang="sass">
  .modal-body,
  .center--text
    text-align: center;

  .sweet-modal .sweet-title
    padding-top: 20px

  .setup-check-ava-locations
    margin-left: 11px;
    margin-bottom: 6px;

  .available-location-container
    margin-left: 11px;
    margin-bottom: 15px;
    max-height: 150px;
    overflow-y: auto;
</style>

<style lang="sass" scoped>
  @import "~leaflet/dist/leaflet.css";

  .alert
    left: 0px !important;
    position: unset !important;
</style>


// WEBPACK FOOTER //
// src/views/pages/location_accuracy/Index.vue